import React, {useCallback, useContext, useEffect, useState} from 'react'
import {
    getAuthHeader, getLocalStorageItem, getPathAndQueryParams,
    objectLang,
    setErrorWindow, setLocalStorageItem,
    setPathBack
} from "../functions"
import {MoneySettingsClass} from "../components/MoneySettingsClass"
import {ModalWin} from "../elements/ModalWin"
import {AuthContext} from "../context/AuthContext"
import {useHttp} from "../hooks/http.hook"
import config from "../config.json"
import {LoaderClass} from "../elements/LoaderClass"

export const MoneySettingsPage = () => {
    setLocalStorageItem('page', 'MoneySettingsPage')
    const auth = useContext(AuthContext)
    const {loading, request} = useHttp()
    const lang = objectLang().language
    const l = lang.lang
    const [settingData, setSettingData] = useState({})
    const [dataModal, setDataModal] = useState({})
    const [allowed, setAllowed] = useState(true)

    if (getLocalStorageItem('isNewMoney')) {
        window.location.replace(`/${l}/money/add-card`)
    }
    setPathBack()
    const getSettings = useCallback(async () => {
        const lang = objectLang().language
        const l = lang.lang
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(
                `${host}/api/money/settings/get`,
                'GET',
                null,
                {
                    Authorization: getAuthHeader(auth)
                })

            if (data.status !== 200 && data.code !== 6041) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code, data.message, '', `replaceTo /${l}/`))
            } else if (data.code !== 6041) {
                setSettingData(data['settings'])
            } else {
                window.location.replace(getPathAndQueryParams())
            }

        } catch (e) {
            window.location.replace(`/${l}/money/main`)
        }
    }, [request, auth])

    useEffect(() => {
        getSettings().then()
    }, [getSettings])

    if (!allowed) {
        return (
            <ModalWin data={dataModal}/>
        )
    }

    if (loading) {
        return (
            <>
                <LoaderClass/>
            </>
        )
    }

    const removeHandler = (cardId) => {
        setAllowed(false)
        setDataModal({
            title: lang.modal.warnings.title,
            desc: lang.body.moneySettingsPage.descRemove,
            btnCancel: lang.modal.warnings.btnCancel,
            btnOK: lang.modal.warnings.btnOK,
            clickOK: `replaceTo /${l}/money/card/remove/${cardId}`,
            clickCancel: 'reload'
        })
    }

    if (!allowed) {
        return <ModalWin data={dataModal}/>
    }

    return (
        <>
            <MoneySettingsClass
                lang={lang}
                settings={settingData}
                removeHandler={removeHandler}
            />
        </>
    )
}